const updateCollectionValidator = ({collection, companyIds}) => {
  if (!collection?.name) throw new Error('Name is required');
  if (!companyIds?.length) throw new Error('Select companies');
};

export default updateCollectionValidator;
